import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles";

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    display: "flex",
    justifyContent: "center",
    alignItems: "flex-start",
    flexDirection: "column",
  },

  mainTitle: {
    letterSpacing: 0,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    [theme.breakpoints.down("desktop")]: {
      flexDirection: "column",
      alignItems: "flex-start",
    },
  },

  title: {
    color: "#000000",
    fontSize: "32px",
  },

  mobile_title: {
    color: "#000000",
    fontSize: "26px",
  },

  precntage: {
    color: "#000000",
    fontSize: "20px",
    margin: "0px 6px",
  },

  mobile_precntage: {
    color: "#000000",
    fontSize: "24px",
    marginBottom: "15px",
  },

  npk: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    color: "#000000",
    fontSize: "20px",
    width: "362px",
    letterSpacing: 0,
  },

  mobile_npk: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    color: "#000000",
    fontSize: "20px",
    width: "262px",
    letterSpacing: 0,
    marginBottom: "24px",
  },
}));

export default useStyles;
